<header>
  <span [ngStyle]="{ color: titleColor }">{{titleText}}</span>
  <a type="button" (click)="close()">
    <i class="fg fg-vuesaxlinearEssetionalclose-circle"></i>
  </a>
</header>
<mat-dialog-content class="mat-typography">
  <p class="text">{{text}}</p>
</mat-dialog-content>
<mat-dialog-actions class="pb-3 d-flex float-right">
  <a type="button" class="mr-3 cancel-button-color" (click)="close()">{{cancelButtonText}}</a>
  <a type="button" class="mr-3 confirm-button-color" (click)="createConsult()">{{confirmButtonText}}</a>
</mat-dialog-actions>
